jQuery(document).ready(function(){
	var $attrsrc1 = $('.imgsection1').attr("src");
	var $attrsrc2 = $('.imgsection2').attr("src");
	if ($attrsrc1.length < 17) {
       $('.imgsection1').hide();
	   $('.footersection1').hide();
	}
	if ($attrsrc2.length < 17) {
       $('.imgsection2').hide();
	   $('.footersection2').hide();
	}
});